import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { FlexContainer } from '@taxdown/piccolo-web';
import { Card, CardSummary } from '@taxdown/kami-sama/dist/kamiSama';
import { history } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import KamiContext from 'Context/KamiContext';
import ReadonlyContext from 'Context/validations';
import HeaderInfo from 'Components/HeaderInfo';
import { WARNING_MODAL } from 'Constants/modals';
import SummaryCard from '../SummaryCard';
import { SummaryGroupProps } from './types';

const SummaryGroup = ({ summaryCardGroup, onUpdate, onDelete }: SummaryGroupProps): JSX.Element => {
  const { onReadOnly, readOnly } = useContext(ReadonlyContext);
  const { forms } = useContext(KamiContext);
  const { title, warningModalTitle, warningModalContent } = summaryCardGroup.getRenderForm();
  const dispatch = useDispatch();

  const editCard = (e: Event, card: Card): void => {
    e.preventDefault();
    const screenId = summaryCardGroup.getEditScreenId();
    if (screenId) {
      const index = card.getIndex();
      history.push(forms[screenId].path, {
        childIndex: index,
      });
      onUpdate();
    }
  };

  const handleOnDelete = (card: Card): void => {
    if (readOnly) {
      onReadOnly();
    } else {
      summaryCardGroup.delete(card);
      onUpdate();
      onDelete();
    }
  };

  const deleteCard = (card: Card): void => {
    const modalOptions = {
      type: WARNING_MODAL,
      action: () => handleOnDelete(card),
    };
    dispatch(
      showModalAction({
        title: warningModalTitle,
        content: warningModalContent,
        options: modalOptions,
      })
    );
  };

  return (
    <FlexContainer direction="column">
      {title && (
        <HeaderInfo tag="h2" mb="dimension_32">
          {title}
        </HeaderInfo>
      )}
      <FlexContainer direction="column">
        {summaryCardGroup.list().map(summaryCard => (
          <SummaryCard
            key={summaryCard.getIndex()}
            summaryCard={summaryCard as CardSummary}
            summaryCardGroup={summaryCardGroup}
            editCard={editCard}
            deleteCard={deleteCard}
          />
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

export default SummaryGroup;
